import { render, staticRenderFns } from "./LinkedDocuments.vue?vue&type=template&id=5f878f47&scoped=true"
import script from "./LinkedDocuments.vue?vue&type=script&lang=js"
export * from "./LinkedDocuments.vue?vue&type=script&lang=js"
import style0 from "./LinkedDocuments.vue?vue&type=style&index=0&id=5f878f47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f878f47",
  null
  
)

export default component.exports